module.exports = __webpack_public_path__ + "static/charity-c5d33348480f945f1d16908fc7215ef2.svg";